import React from 'react';
import './WhatsAppButton.css';
import { getQuotationWhatsAppLink, QUOTATION_LABEL } from '../../constants/quotation';
import { logEvent } from '../Analytics';

const WhatsAppButton = ({ messagePrefix }) => {
  const chatUrl = getQuotationWhatsAppLink(messagePrefix);
  const handleClick = () => {
    logEvent({ action: 'whatsapp_button_click', label: QUOTATION_LABEL });
  };
  return (
    <div className="whatsapp-button">
      <a
        href={chatUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Abrir chat de WhatsApp"
        onClick={handleClick}
      >
        <span className="whatsapp-button__sr-only">Chatear en WhatsApp</span>
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fill="currentColor"
            d="M20.52 3.48A11.86 11.86 0 0 0 12.09 0C5.52.06.25 5.36.28 11.93a11.8 11.8 0 0 0 1.76 6.25L0 24l6.05-1.9a11.94 11.94 0 0 0 6 1.61h.01c6.56 0 11.9-5.34 11.91-11.92A11.84 11.84 0 0 0 20.52 3.48Zm-8.43 18.4h-.01a10 10 0 0 1-5.09-1.39l-.36-.21-3.6 1.13 1.17-3.5-.24-.37a9.96 9.96 0 0 1-1.51-5.28C2.45 6.53 6.64 2.32 11.98 2.32a9.72 9.72 0 0 1 6.94 2.89 9.7 9.7 0 0 1 2.88 6.94c-.01 5.4-4.4 9.73-9.71 9.73Zm5.33-7.33c-.29-.15-1.72-.85-1.99-.94s-.46-.15-.66.15-.75.94-.92 1.13-.34.22-.63.07a7.92 7.92 0 0 1-2.33-1.44 8.77 8.77 0 0 1-1.63-2c-.17-.3 0-.46.13-.61.13-.14.3-.34.45-.5.15-.17.2-.29.3-.49.1-.2.05-.38-.02-.54-.07-.15-.66-1.59-.9-2.17-.24-.58-.48-.5-.66-.51-.17-.01-.37-.01-.57-.01s-.53.07-.81.38c-.28.3-1.06 1.04-1.06 2.55s1.08 2.96 1.23 3.17c.15.2 2.15 3.28 5.21 4.6.73.32 1.3.51 1.74.65.73.23 1.4.2 1.92.12.59-.09 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34Z"
          />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppButton;
